export tag Project
	prop db
	prop project

	def routed params, state
		# console.log db
		let paramTitle = global.decodeURI(params.title).toLowerCase().replace(/\s+/g, '')
		project = state.project ||= await db.getProject(paramTitle)

	def render
		let imageUrl = `url('{project[0].cover}')`
		<self[bgc:{project[0].bg}]>
			<section.project>
				<div.banner[bgi:{imageUrl} c:{project[0].font}]>
					<h5> project[0].type
					<h1> project[0].name
				<div.project-detail[c:{project[0].font}]>
					<div.information>
						<div.description>
							<h2> project[0].title
							<p> project[0].subtitle
						<div.project-info>
							<h6> "Category"
							<p> project[0].type
							<hr />
							<h6> "Years"
							<p> project[0].year
					<div.screenshots>
						for paragraph in project[0].desc
								if paragraph.type === 'line'
									<p> paragraph.content
								if paragraph.type === 'img'
									<img[w:100%] src="{paragraph.content}">
								if paragraph.type === 'subhead'
									<h5> paragraph.content
								if paragraph.type === 'list'
									<ul>
										for listitem in paragraph.content
											<li> listitem

	def rendered
		if !project
			imba.router.go('/')

	css .project
			.banner w:100% h:100vh jc:center ai:center d:flex bgs:cover fld:column
				h1 fs:4rem mt:0 fw:600
					@!799 fs:3rem
				h5 mb:0 fw:600
			.project-detail max-width:1200px m:0 auto pb:1rem pt:1.5rem
				@!799 px:1.5rem
				h2 fw:600 lh:1.8rem
					@!799 fs:1.3rem
				h5 fs:1.5rem mb:0.3rem fw:600
					@!799 fs:0.9rem
				p mb:2rem py:0rem mt:0
					@!799 fs:0.8rem
				h6 fs:0.7rem mb:0 pb:0 o:0.3 fw:500
				ul pl:1.8rem
					li
						@!799 fs:0.8rem
				.information d:flex
					.description w:67% mr:3%
					.project-info w:29% ml:1%
				.screenshots ta:justify
